import { endlessPaginate } from "endless_pagination/endless-pagination-module.js";
import { MovieGLightbox } from "../../common/image_gallery.js";

function ready(fn) {
	if (document.readyState !== "loading") {
		fn();
	} else {
		document.addEventListener("DOMContentLoaded", fn);
	}
}

ready(() => {
	// galleria paginata
	const gallery_data = document.querySelector("#_gallery-section");
	const main_gallery = new MovieGLightbox({
		url: `/misc/immagini/${gallery_data.dataset.ct}/${gallery_data.dataset.id}/`,
		per_page: 36,
		selector: gallery_data.dataset.gallerySelector,
	});
	endlessPaginate({
		onCompleted: (context, fragment) => {
			const endless_url = new URL(context.url, window.location.origin);
			const qs = endless_url.searchParams;
			const page = Number.parseInt(qs.get(context.key));
			main_gallery.fetchPage(page);
		},
	});
});
